module.exports = __webpack_public_path__ + "img/home-04-testimonial.df679bce.png";